import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import styles from "./Modal.module.css";

let openModalsCount = 0;

const Modal = ({
	isOpen,
	onClose,
	title,
	children,
	size = "medium",
	showCloseButton = true,
	closeOnOverlayClick = true,
	footer,
	loading = false,
	className,
}) => {
	const prevOpenState = useRef(false);

	useEffect(() => {
		const handleEsc = (event) => {
			if (event.key === "Escape" && isOpen) {
				onClose();
			}
		};

		if (isOpen) {
			document.addEventListener("keydown", handleEsc);
		}

		return () => {
			document.removeEventListener("keydown", handleEsc);
		};
	}, [isOpen, onClose]);

	useEffect(() => {
		if (isOpen && !prevOpenState.current) {
			openModalsCount++;

			if (openModalsCount === 1) {
				document.body.style.overflow = "hidden";
			}
		} else if (!isOpen && prevOpenState.current) {
			openModalsCount = Math.max(0, openModalsCount - 1);

			if (openModalsCount === 0) {
				document.body.style.overflow = "unset";
			}
		}

		prevOpenState.current = isOpen;

		return () => {
			if (prevOpenState.current) {
				openModalsCount = Math.max(0, openModalsCount - 1);
				if (openModalsCount === 0) {
					document.body.style.overflow = "unset";
				}
			}
		};
	}, [isOpen]);

	if (!isOpen) return null;

	const handleOverlayClick = (e) => {
		if (closeOnOverlayClick && e.target === e.currentTarget) {
			onClose();
		}
	};

	const modalContent = (
		<div className="modal-overlay" onClick={handleOverlayClick}>
			<div
				className={`modal-container ${styles[size]} ${className || ""}`}
				onClick={(e) => e.stopPropagation()}
			>
				{loading && <div className="modal-loading" />}

				<div className="modal-header">
					<h2>{title}</h2>
					{showCloseButton && (
						<button
							className="modal-close-btn"
							onClick={onClose}
							aria-label="Close modal"
						>
							<FontAwesomeIcon icon={faTimes} />
						</button>
					)}
				</div>

				<div className="modal-body">{children}</div>

				{footer && <div className="modal-footer">{footer}</div>}
			</div>
		</div>
	);

	return createPortal(modalContent, document.body);
};

export default Modal;
